import $ from 'jquery'

$(function () {
  /**
   * グローバルナビのメニューボタンクリック
   */
  $('.js-gnav-btn').on('click', () => {
    $('body').toggleClass('open-menu')
  })

  /**
   * スクロールアニメーション
   */
  $(window).on('scroll', () => {
    $('.js-anim:not(.is-show),.js-over-middle').each(function () {
      const $target = $(this)
      const point = (ratio) => {
        return $(window).scrollTop() + $(window).height() * ratio
      }

      if ($target.hasClass('js-over-middle')) {
        if ($target.offset().top + $target.outerHeight() * 0.5 < point(0.5)) {
          $target.addClass('is-over')
        } else {
          $target.removeClass('is-over')
        }
        return true
      }

      if ($target.offset().top < point(0.6)) {
        $target.addClass('is-show')
      }
    })
  })

  /**
   * 下層ページのサイドアンカーリンク
   */
  const $anchorWrap = $('.pageContainer__side')
  const $anchorLinks = $('.pageContainer__navList')
  if ($anchorLinks.length) {
    $(window).on('load scroll', () => {
      const point = $(window).scrollTop() + $(window).height() * 0.5
      $anchorLinks.each(function () {
        const $self = $(this)

        // 対象のアンカー先のセクションに入っているかチェック
        const id = $self.find('a').attr('href')
        if ($(id).length) {
          if ($(id).offset().top <= point && point <= $(id).offset().top + $(id).outerHeight()) {
            $self.addClass('is-current')
            $self.removeClass('is-invert')
            return
          } else {
            $self.removeClass('is-current')
          }
        } else {
          $self.removeClass('is-current')
        }

        // アンカーリンクの反転エリアに入っているかチェック
        $('.js-index-invert').each(function () {
          const $target = $(this)
          if (
            $target.offset().top <= $self.offset().top &&
            $self.offset().top <= $target.offset().top + $target.outerHeight()
          ) {
            $self.addClass('is-invert')
          } else {
            $self.removeClass('is-invert')
          }
        })
      })

      // SP用
      if ($(window).height() * 0.5 < $(window).scrollTop() && point < $('.footer').offset().top) {
        $anchorWrap.addClass('is-sp-show')
      } else {
        $anchorWrap.removeClass('is-sp-show')
      }
    })
  }
})
